import type { MetricRecordData } from "@/types/metrics/contracts"

const TRANSCRIPT_FILTER_SUPPORTED_MANAGERS = [
  "manager_llm_binary",
  "manager_numerical_llm_judge",
  "manager_default_categorical",
  "manager_agent_repeats_itself",
  "manager_sentimentanalysis",
  "manager_composite_evaluation",
] as const

const TRACE_CONTEXT_SUPPORTED_MANAGERS = [
  "manager_llm_binary",
  "manager_default_categorical",
  "manager_numerical_llm_judge",
  "manager_audio_llm_judge",
  "manager_audio_llm_binary",
  "manager_audio_llm_categorical",
  "manager_audio_llm_numerical",
  "manager_composite_evaluation",
] as const

const AUDIO_FILTER_SUPPORTED_MANAGERS = [
  "manager_abrupt_pitch_changes",
  "manager_agent_needs_reprompting",
  "manager_audio_frequency",
  "manager_audio_llm_binary",
  "manager_audio_llm_categorical",
  "manager_audio_llm_judge",
  "manager_audio_llm_numerical",
  "manager_audio_sentiment",
  "manager_clipping_artifact",
  "manager_codec_artifact",
  "manager_custom_agent_needs_reprompting",
  "manager_custom_audio_frequency",
  "manager_dropout_artifact",
  "manager_loop_detection",
  "manager_lufs",
  "manager_music_detection",
  "manager_non_expressive_pauses",
  "manager_phoneme_stretch",
  "manager_phonemes_per_second",
  "manager_pitch_variability",
  "manager_signal_to_noise_ratio",
  "manager_terminal_contour",
  "manager_speaking_time_percentage",
  "manager_spectrogram_pitch_analysis",
  "manager_speech_artifact_anomaly",
  "manager_syllable_rate",
  "manager_time_to_first_audio",
  "manager_timbre_drift",
  "manager_transcription_error",
  "manager_vocal_fry",
  "manager_voice_quality",
  "manager_volume",
  "manager_volume_pitch_misalignment",
  "audio_duration_metric_manager",
  "interruption_rate_manager",
  "pause_analysis_metric",
] as const

const MODEL_SELECTION_SUPPORTED_MANAGERS = [
  "manager_llm_binary",
  "manager_default_categorical",
  "manager_numerical_llm_judge",
] as const

const AGENT_JUDGE_TOOL_SUPPORTED_MANAGERS = [
  "manager_agentic_llm_judge",
  "manager_agentic_llm_judge_categorical",
  "manager_agentic_llm_judge_numerical",
] as const

export function supportsTranscriptFilter(
  metricRecordData: MetricRecordData,
): boolean {
  return TRANSCRIPT_FILTER_SUPPORTED_MANAGERS.includes(
    metricRecordData.metric_manager as (typeof TRANSCRIPT_FILTER_SUPPORTED_MANAGERS)[number],
  )
}

export function supportsTraceContext(
  metricRecordData: MetricRecordData,
): boolean {
  return TRACE_CONTEXT_SUPPORTED_MANAGERS.includes(
    metricRecordData.metric_manager as (typeof TRACE_CONTEXT_SUPPORTED_MANAGERS)[number],
  )
}

export function supportsAudioFilter(
  metricRecordData: MetricRecordData,
): boolean {
  return AUDIO_FILTER_SUPPORTED_MANAGERS.includes(
    metricRecordData.metric_manager as (typeof AUDIO_FILTER_SUPPORTED_MANAGERS)[number],
  )
}

export function supportsModelSelection(
  metricRecordData: MetricRecordData,
): boolean {
  return MODEL_SELECTION_SUPPORTED_MANAGERS.includes(
    metricRecordData.metric_manager as (typeof MODEL_SELECTION_SUPPORTED_MANAGERS)[number],
  )
}

export function supportsAgentJudgeTools(
  metricRecordData: MetricRecordData,
): boolean {
  return AGENT_JUDGE_TOOL_SUPPORTED_MANAGERS.includes(
    metricRecordData.metric_manager as (typeof AGENT_JUDGE_TOOL_SUPPORTED_MANAGERS)[number],
  )
}
